export const profileSummaryStyles = {
  card: {
    borderRadius: 3,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    mb: 4,
    overflow: 'hidden',
    position: 'relative',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },

  cardContent: {
    p: { xs: 2, sm: 4 },
    color: 'white',
    position: 'relative',
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'center', sm: 'initial' },
  },

  backgroundDecoration: {
    position: 'absolute',
    top: { xs: -10, sm: -20 },
    right: { xs: -10, sm: -20 },
    width: { xs: 50, sm: 100 },
    height: { xs: 50, sm: 100 },
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.1)',
  },

  container: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
    width: '100%',
    textAlign: { xs: 'center', sm: 'left' },
  },

  avatar: {
    width: { xs: 64, sm: 90 },
    height: { xs: 64, sm: 90 },
    fontSize: { xs: '1.5rem', sm: '2.2rem' },
    fontWeight: 700,
    backgroundColor: 'rgba(255,255,255,0.2)',
    backdropFilter: 'blur(10px)',
    border: '3px solid rgba(255,255,255,0.3)',
    mr: { xs: 0, sm: 3 },
    mb: { xs: 1.5, sm: 0 },
    color: 'white',
    mx: { xs: 'auto', sm: 0 },
  },

  userInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'center', sm: 'flex-start' },
    justifyContent: 'center',
  },

  userName: {
    fontWeight: 700,
    mb: 1,
    color: 'white',
    fontSize: { xs: '1.2rem', sm: '2rem' },
  },

  userDetails: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 1, sm: 2 },
    mb: 1,
    flexDirection: { xs: 'column', sm: 'row' },
  },

  roleChip: {
    backgroundColor: 'rgba(255,255,255,0.9)',
    color: '#667eea',
    fontWeight: 600,
    fontSize: { xs: '0.8rem', sm: '1rem' },
    mb: { xs: 0.5, sm: 0 },
    ml: 1.5,
  },

  userTitle: {
    color: 'rgba(255,255,255,0.9)',
    fontSize: { xs: '1rem', sm: '1.1rem' },
  },

  startDate: {
    color: 'rgba(255,255,255,0.8)',
    fontSize: { xs: '0.95rem', sm: '1rem' },
    mt: { xs: 1, sm: 0 },
  },

  editButton: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    color: 'white',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255,255,255,0.3)',
    mt: { xs: 1, sm: 0 },
    alignSelf: { xs: 'center', sm: 'flex-start' },
    order: { xs: 3, sm: 0 },
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.3)',
      transform: 'scale(1.05)',
    },
    transition: 'all 0.2s ease',
    p: { xs: 0.5, sm: 1 },
    fontSize: { xs: '1rem', sm: '1.25rem' },
  },
}; 